<template>
    <div class="storage-config">
      <div class="page-header">
        <h2 class="page-title">存储配置</h2>
        <p class="page-desc">配置云存储服务，用于图片、文件等资源的存储</p>
      </div>
  
      <div class="config-container">
        <el-card class="config-card" shadow="hover">
          <template #header>
            <div class="card-header-title">
              <el-icon><FolderOpened /></el-icon>
              <span>存储服务配置</span>
            </div>
          </template>
  
          <el-form :model="form" ref="formRef" label-width="120px">
            <el-form-item label="存储类型" required>
              <el-select v-model="form.storage_type" placeholder="请选择存储类型" style="width: 300px" @change="onStorageTypeChange">
                <el-option label="阿里云 OSS" value="aliyun" />
                <el-option label="腾讯云 COS" value="tencent" disabled />
                <el-option label="七牛云 Kodo" value="qiniu" disabled />
                <el-option label="S3 系列存储" value="s3" disabled />
              </el-select>
              <div class="form-tip">其他存储类型即将开放，敬请期待</div>
            </el-form-item>
  
            <template v-if="form.storage_type === 'aliyun'">
              <el-form-item label="阿里云ID">
                <el-input v-model="form.aliyun_keyid" placeholder="请输入阿里云 AccessKey ID" />
              </el-form-item>
  
              <el-form-item label="阿里云密钥">
                <el-input v-model="form.aliyun_secret" type="password" placeholder="请输入阿里云 AccessKey Secret" show-password />
              </el-form-item>
  
              <el-form-item label="Endpoint">
                <el-input v-model="form.endpoint" placeholder="例：oss-cn-shanghai.aliyuncs.com" />
                <div class="form-tip">
                  华东1：oss-cn-shanghai.aliyuncs.com<br>
                  华北2：oss-cn-beijing.aliyuncs.com
                </div>
              </el-form-item>
  
              <el-form-item label="Bucket名称">
                <el-input v-model="form.aliyun_bucket" placeholder="请输入Bucket名称" />
              </el-form-item>
            </template>
  
            <el-form-item class="save-btn-item">
              <el-button type="primary" @click="saveConfig" :loading="submitting" size="default" class="save-btn">
                <el-icon><Check /></el-icon>保存配置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import config from '@/config'
  import { FolderOpened, Check } from '@element-plus/icons-vue'
  
  export default {
    name: 'StorageConfig',
    components: { FolderOpened, Check },
    setup() {
      const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
      const storeId = ref(userInfo.id || 0)
      const agentId = ref(userInfo.agent_id || 0)
  
      const formRef = ref(null)
      const submitting = ref(false)
  
      const form = reactive({
        storage_type: 'aliyun',
        aliyun_keyid: '',
        aliyun_secret: '',
        endpoint: '',
        aliyun_bucket: ''
      })
  
      const fetchConfig = async () => {
        const loading = ElLoading.service({ text: '加载中...' })
        try {
          const res = await axios.get(`${config.BASE_URL}/shop/api/storage_api.php`, {
            params: { store_id: storeId.value, agent_id: agentId.value }
          })
          if (res.data.code === 200 && res.data.data) {
            Object.assign(form, res.data.data)
          }
        } catch (err) {
          console.error(err)
          ElMessage.error('获取配置失败')
        } finally {
          loading.close()
        }
      }
  
      const onStorageTypeChange = () => {
        if (form.storage_type !== 'aliyun') {
          ElMessage.info('其他存储类型暂未开放，敬请期待')
          form.storage_type = 'aliyun'
        }
      }
  
      const saveConfig = async () => {
        submitting.value = true
        const loading = ElLoading.service({ text: '保存中...' })
  
        try {
          const payload = {
            store_id: storeId.value,
            agent_id: agentId.value,
            storage_type: form.storage_type,
            aliyun_keyid: form.aliyun_keyid,
            aliyun_secret: form.aliyun_secret,
            endpoint: form.endpoint,
            aliyun_bucket: form.aliyun_bucket
          }
          const res = await axios.post(`${config.BASE_URL}/shop/api/storage_api.php`, payload)
  
          if (res.data.code === 200) {
            ElMessage.success('保存成功')
          } else {
            ElMessage.error(res.data.message || '保存失败')
          }
        } catch (err) {
          ElMessage.error('保存失败')
        } finally {
          submitting.value = false
          loading.close()
        }
      }
  
      onMounted(() => {
        fetchConfig()
      })
  
      return {
        form,
        formRef,
        submitting,
        saveConfig,
        onStorageTypeChange
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .storage-config {
    .page-header {
      margin-bottom: 24px;
  
      .page-title {
        font-size: 24px;
        font-weight: 600;
        color: #1a1a2e;
        margin-bottom: 4px;
      }
  
      .page-desc {
        font-size: 14px;
        color: #8c8c8c;
      }
    }
  
    .config-container {
      width: 100%;
      max-width: 800px;
    }
  
    .config-card {
      border-radius: 16px;
      overflow: hidden;
    }
  
    .card-header-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 500;
    }
  
    .form-tip {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
      margin-left: 5px;
      line-height: 1.4;
    }
  
    .save-btn-item {
      margin-top: 16px;
    }
  
    .save-btn {
      padding: 8px 24px;
      font-size: 14px;
      font-weight: 500;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
      border: none !important;
    }
  }
  </style>